import { useEffect, useRef, useState } from 'react';

/**
 * Определяет, что страница прокручена ниже заданной точки.
 *
 * Используется «сторож» и IntersectionObserver вместо слушателя `scroll`:
 * обработчик прокрутки выполняется на каждом кадре и мешает главному потоку.
 */
export function useStuck<T extends HTMLElement>() {
  const sentinelRef = useRef<T>(null);
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          setStuck(!entry.isIntersecting);
        }
      },
      { threshold: 0 },
    );

    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, []);

  return { sentinelRef, stuck };
}
